import { formatPrice } from "@/lib/cart/pricing";
import type { CatalogProduct } from "@/lib/catalog/products";

export type SizeVariant = {
  id: string;
  label: string;
  ml: number;
};

export const DEFAULT_SIZES: SizeVariant[] = [
  { id: "10", label: "10 ml", ml: 10 },
  { id: "20", label: "20 ml", ml: 20 },
  { id: "50", label: "50 ml", ml: 50 },
  { id: "100", label: "100 ml", ml: 100 },
];

/** The size selected by default on the PDP (100 ml is the hero bottle). */
export const DEFAULT_SIZE: SizeVariant =
  DEFAULT_SIZES.find((s) => s.id === "100") ?? DEFAULT_SIZES[0];

export function getRelated(product: CatalogProduct, products: CatalogProduct[], limit = 4): CatalogProduct[] {
  const sameCollection = products.filter(
    (p) => p.id !== product.id && p.collectionId === product.collectionId,
  );
  const sameFamily = products.filter(
    (p) =>
      p.id !== product.id && p.family === product.family && p.collectionId !== product.collectionId,
  );
  const seen = new Set<string>();
  const combined = [...sameCollection, ...sameFamily].filter((p) => {
    if (seen.has(p.id)) return false;
    seen.add(p.id);
    return true;
  });
  return combined.slice(0, limit);
}

/**
 * Single source of truth for money display: delegates to the canonical
 * pricing service formatter (INR).
 */
export function formatINR(v: number): string {
  return formatPrice(Math.round(v));
}

/**
 * Deterministic gallery expansion: reuses the catalog's shared image bank so
 * the PDP has multiple viewable images without introducing new assets.
 */
export function getGalleryImages(product: CatalogProduct): string[] {
  return [product.img, ...(product.gallery ?? [])].filter(Boolean).slice(0, 5);
}

